import axios from 'axios';
import { Effect, RequestResolver } from 'effect';
import * as Url from '../../api/url';
import { GetSpacesError, SpacesParseError } from './requests';
import * as S from '@effect/schema/Schema';
import { ConfigurationSpaces } from '../../schemas/aspect/configurationSpace';
const parse = S.decodeUnknown(ConfigurationSpaces);
export const getSpacesResolver = (spacesUrl) => {
    return RequestResolver.fromEffect((request) => Effect.tryPromise({
        try: () => axios
            .get(Url.toString({
            base: spacesUrl,
            path: `/${request.tenant}/furniture-spaces`,
            query: {},
        }), { headers: { Authorization: `Bearer ${request.bearerToken}` } })
            .then(res => res.data),
        catch: error => new GetSpacesError(error),
    }).pipe(Effect.flatMap(data => parse(data).pipe(Effect.mapError(originalError => new SpacesParseError({ originalError }))))));
};
